<template>
  <div class="mine-menu" @scroll="handleScroll">
    <div class="mine-menu-top">
      <MenuHeader title="我的" />
      <TagMenu v-model="currentOp" :tagList="tagList" />
      <!-- 我的上传 -->
      <div v-show="currentOp == 'upload'" class="preset_view">
        <button
          type="button"
          v-for="item in uploadTypes"
          :key="item.value"
          @click="uploadTypeClick(item)"
          class="material-category__item"
          :class="{ 'material-category__item--active': item.value === uploadType }"
        >
          {{ item.title }}
      </button>
      </div>
      <!-- 我的上传end -->
      <a-input-group class="search-box" v-if="searchShowing">
        <a-button
          @click="clearSecondTag"
          v-if="
            collectType && collectType !== 'temple' && collectType !== 'snippet'
          "
        >
          返回
        </a-button>
        <template v-else>
          <el-tooltip content="返回" v-if="currentOp !== 'mine-temple'&& currentOp != 'upload'">
            <a-button
              class="ant-input-group-addon ant-btn-icon-only"
              @click="clearSecondTag"
            >
              <span class="el-icon-back"></span>
            </a-button>
          </el-tooltip>
          <a-input-search
            name="minesearch"
            @search="onSearch"
            placeholder="请输入搜索关键字"
            v-model="editingKeyword"
          />
        </template>
      </a-input-group>
      <div class="check-operation" v-if="uploadType||currentOp=='upload'">
        <template v-if="myMateriaChecked">
          <a-button type="danger" @click="batchDelete">
            <a-icon theme="filled" type="delete" />
            删除
          </a-button>
          <a-button @click="cancelCheck">取消</a-button>
        </template>
        <template  v-else>
          <template v-if="currentOp=='upload'&&uploadType=='1,2'">
            <div class="upload-box">
              <a-button
                type="primary"
                block
                @click="openUploadModal"
                key="upload"
              >
                本地上传
              </a-button>
              <a-popover
                :visible="codeBoxShow"
                @visibleChange="toggleCodeBoxDialog"
                placement="right"
                trigger="click"
              >
                <div class="code-box" slot="content">
                  <div ref="qrcode" class="qrcode" id="qrcode"></div>
                  <div class="qrcode-overdue" v-if="qrcodeOverdue">
                    二维码已过期，请<span @click="repaintQrcode">重新生成</span>
                  </div>
                </div>
                <a-button class="upload-type" type="primary"> 手机上传 </a-button>
              </a-popover>
            </div>
          </template>
          <template v-else>
            <a-button
                type="primary"
                block
                @click="openUploadModal"
                key="upload"
              >
                上传本地文件
            </a-button>
          </template>
        </template>
      </div>
    </div>
    <div
      class="empty"
      :style="{
        height: spacerHeight + 'px'
      }"
    ></div>
    <!-- 我的收藏 -->
    <div v-show="currentOp == 'collect' && !collectType">
      <a-button
        v-for="item in collectTypes"
        :key="item.value"
        @click="collectTypeClick(item)"
        class="preset-type-item"
        :icon="item.icon"
      >
        <a-icon
          v-if="item.customIcon"
          :component="icons[item.customIcon]"
          class="preset-type-item__icon"
        />
        <span
          class="anticon iconfont preset-type-item__icon"
          v-else-if="item.iconfont"
        >
          {{ item.iconfont }}
        </span>
        {{ item.title }}
      </a-button>
    </div>
    <!-- 我的收藏 - 动画/贴纸 -->
    <MaterialList
      v-show="
        collectType == 'decal' ||
        collectType == 'anime' ||
        collectType == 'effects'
      "
      :dataList="materialList"
      :loading="loading"
      :presetType="collectType === 'effects' ? 'anime' : collectType"
      :lottieType="collectType == 'effects' ? 2 : 1"
    ></MaterialList>
    <!-- 我的收藏 - 片段 -->
    <SnippetList
      v-show="collectType == 'snippet'"
      :dataList="templateList"
      :loading="loading"
    ></SnippetList>
    <!-- 我的上传 - 音乐 -->
    <MusicInfo
      v-show="uploadType == 'music' || collectType === 'music'"
      :dataList="musicList"
      :loadingStatus="loading"
      :currentOp="currentOp === 'collect' ? 'public' : 'myMusic'"
      @top="handleMusicTop"
      @delete="handleMusicDelete"
      :likeOnly="currentOp === 'collect'"
      :music.sync="music"
    ></MusicInfo>
    <!-- 我的上传 - 图片/视频 -->
    <MaterialStyleList
      :isCollect="collectType == 'material'"
      :dataList="materialList"
      :loadingStatus="loading"
      :fn="addMaterialItem"
      :replace="replaceMaterialItem"
      :handleStampUrl="handleStampUrl"
      :editStatus="editStatus"
      v-show="
        (currentOp=='upload'|| collectType == 'material')&&uploadType!='music'
      "
      :mine="uploadType && uploadType != 'music'"
      @top="handleTop"
      @delete="handleDelete"
    ></MaterialStyleList>
    <!-- 我的收藏 - 模板 || 我的模板 -->
    <VideoTemplateList
      :isCollect="currentOp !== 'mine-temple'"
      v-show="currentOp == 'mine-temple' || collectType == 'temple'"
      :dataList="videoTemplateList"
      :loading="loading"
    ></VideoTemplateList>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { get } from "../../utils/api";
import webSocket from '../../utils/webSocket';
import { mapActions, mapState, mapMutations } from 'vuex';
import { message } from 'ant-design-vue';
import MenuHeader from '../base/MenuHeader';
import TagMenu from '../base/TagMenu';
// import LabelOption from '../base/LabelOption';
import MaterialStyleList from "../base/MaterialStyleList";
import MaterialList from "../base/MaterialList";
import VideoTemplateList from "../base/VideoTemplateList";
import SnippetList from "./SnippetList";
import MusicInfo from "../music/MusicInfo";
import icons from '../material/materialTypeIcons';

export default {
  name: "MineMenu",
  components: { MenuHeader, TagMenu, MaterialStyleList, MaterialList, VideoTemplateList, SnippetList, MusicInfo },
  data: function () {
    return {
      tagList: [{ tag: '我的上传', op: 'upload' },{ tag: '我的收藏', op: 'collect' },{ tag: '我的模板', op: 'mine-temple' }],
      currentOp: 'upload',
      icons,
      uploadTypes: [
        { title: '图片&视频', value: '1,2', icon: 'picture' },
        // { title: '视频', value: '2', icon: 'video-camera' },
        { title: '音乐', value: 'music', iconfont: '\ue65f' },
      ],
      uploadType: '',
      loading: true,
      collectTypes: [
        { title: '模板', value: 'temple', customIcon: 'template' },
        { title: '片段', value: 'snippet', customIcon: 'fragment' },
        { title: '音乐', value: 'music', iconfont: '\ue65f' },
        { title: '特效', value: 'effects', customIcon: 'effect' },
        { title: '动画', value: 'anime', customIcon: 'lottie' },
        { title: '贴纸', value: 'decal', icon: 'smile' },
        { title: '系统素材', value: 'material', icon: 'folder-open' }
      ],
      collectType: '',
      page: 1,
      keyword: '',
      editingKeyword: '',
      music: {},
      codeBoxShow: false,
      qrcodeOverdue: false
    }
  },
  computed: {
    ...mapState([
      'videoTemplateList',
      'materialList',
      'editStatus',
      'templateList',
      'musicList',
      'uploadModalMarker',
      'myMateriaCheckedList',
      'myMateriaChecked'
    ]),
    isDark() {
      const { userBasics } = this.$store.state;
      if (userBasics) {
        return userBasics.color === '#000';
      }
      return false;
    },
    searchShowing() {
      return this.uploadType || this.collectType || this.currentOp == 'mine-temple'||this.currentOp=='upload';
    },
    spacerHeight() {
      return this.currentOp=='upload'?209:this.uploadType ? 175 : this.searchShowing ? 135 : 96;
    },
    fetchMarker() {
      return [
        this.uploadType ? this.uploadModalMarker : '',
        this.currentOp,
        this.uploadType,
        this.collectType,
        this.keyword
      ].join(',');
    }
  },
  mounted() {
    var _t =this;
    _t.uploadTypeClick(_t.uploadTypes[0])
    this.listenerWebscoket();
  },
  methods: {
    ...mapActions([
      'addMaterialItem',
      "getMusicList",
      'getMaterialList',
      'replaceMaterialItem',
      'setMaterialTop',
      'deleteMaterial',
      'getVideoTemplateList',
      'getMineCollectTemplates',
      'getMineCollectSnippets',
      'getMineCollectAnimes',
      'getMineCollectDecals',
      'getMineCollectMaterials',
      'getMineCollectMusics',
      'getMineCollectEffects'
    ]),
    ...mapMutations([
      'handleStampUrl',
      "handleMusicList",
      'handleUploadModalShow',
      'handleUploadModalType',
      'handleMyMateriaChecked',
      'handleMyMateriaCheckedList'
    ]),
    onSearch: function (search) {
      this.keyword = search;
    },
    uploadTypeClick(item) {
      console.log(item);
      this.uploadType = item.value;
    },
    // 获取上传音乐
    fetchMusicList: function (getMore = false) {
      if (!getMore) {
        this.lastPage = false;
        this.page = 1;
        this.handleMusicList([]);
      }
      if (this.lastPage) {
        return;
      }
      this.loading = "loading";
      const { order, page, keyword } = this;
      return this.getMusicList({ order, page, material: keyword, u_id: "" }).then((val) => {
        this.lastPage = val.lastPage;
        this.page++;
        this.loading = "loaded";
        setTimeout(this.handleScroll, 300);
      });
    },
    // 获取上传素材（视频图片）
    fetchMaterialList(getMore = false) {
      if (!getMore) {
        this.page = 1;
        this.lastPage = false;
        this.$store.commit('handleMaterialList', []);
      }
      if (this.lastPage) {
        return;
      }
      const { order, page, keyword } = this;
      this.loading = 'loading';
      return this.getMaterialList({
        order,
        page,
        u_id: "",
        material_type: this.uploadType,
        material: keyword
      }).then((val) => {
        this.lastPage = val.lastPage;
        this.page++;
        this.loading = "loaded";
        setTimeout(this.handleScroll, 300);
      });
    },
    // 置顶
    async handleTop({ id, value }) {
      await this.setMaterialTop({ id, value });
      message.info(value ? '置顶成功' : '取消置顶成功');
      await this.fetchMaterialList();
    },
    // 删除
    handleDelete({ id }) {
      this.deleteMaterial({
        id,
        done: this.fetchMaterialList
      });
    },
    // 置顶
    async handleMusicTop({ id, value }) {
      await this.setMaterialTop({ id, value });
      message.info(value ? '置顶成功' : '取消置顶成功');
      await this.fetchMusicList();
    },
    // 删除
    // id is the event itself not the field
    handleMusicDelete(id) {
      this.deleteMaterial({
        id,
        done: this.fetchMusicList
      });
    },
    // 我的收藏
    collectTypeClick(item) {
      this.collectType = item.value
    },
    async collectGetList(fn, next) {
      if (!next) {
        this.page = 1;
        this.lastPage = false;
      }

      if (!this.lastPage) {
        this.loading = 'loading';

        const ret = await this[fn]({
          keyword: this.keyword,
          page: this.page
        });
        if (ret) {
          this.lastPage = ret.last;
          this.page++;
          this.loading = "loaded";

          setTimeout(this.handleScroll, 300);
        }
      }
    },
    // 获取我的模板
    async processGetTemplateList(next) {
      if (!next) {
        this.page = 1;
        this.lastPage = false;
      }

      if (!this.lastPage) {
        this.loading = 'loading';

        const ret = await this.getVideoTemplateList({
          keyword: this.keyword,
          tab: 'mine',
          page: this.page
        });
        if (ret) {
          this.lastPage = ret.last;
          this.page++;
          this.loading = "loaded";

          setTimeout(this.handleScroll, 300);
        }
      }
    },
    handleScroll() {
      const menu = this.$el;
      if (this.loading == 'loading') {
        return;
      }
      if (menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 30) {
        if (this.currentOp == 'upload') {
          if (this.uploadType == 'music') {
            this.fetchMusicList(true);
          } else {
            this.fetchMaterialList(true);
          }
        } else if (this.currentOp == 'collect' && this.collectType) {
          this.requestCollect(true);
        } else if (this.currentOp == 'mine-temple') {
          this.processGetTemplateList(true);
        }
      }
    },
    // 清除二级标记
    clearSecondTag() {
      if(this.currentOp=='upload'){
        this.uploadType = '1,2';
      }else{
        this.uploadType = '';
      }
      this.collectType = '';
      this.keyword = '';
      this.editingKeyword = '';
    },
    requestCollect(next) {
      const typeLookup = {
        temple: 'getMineCollectTemplates',
        snippet: 'getMineCollectSnippets',
        music: 'getMineCollectMusics',
        anime: 'getMineCollectAnimes',
        decal: 'getMineCollectDecals',
        material: 'getMineCollectMaterials',
        effects: 'getMineCollectEffects'
      };
      this.collectGetList(typeLookup[this.collectType], next);
    },
    openUploadModal() {
      this.handleUploadModalShow(true);
      this.handleUploadModalType(this.uploadType === 'music' ? 4 : 3);
    },
    async toggleCodeBoxDialog(nextShow) {
      if (nextShow) {
        var codeUrl = await get('qrcode/material-url');
        this.codeBoxShow = true;
        this.qrcodeOverdue = false;
        this.$nextTick(() => {
          this.$refs.qrcode.innerHTML = "";
          new QRCode(this.$refs.qrcode, {
            text: codeUrl.url,
            width: 200,
            height: 200
          });
        });
      } else {
        this.codeBoxShow = false;
      }
    },
    async listenerWebscoket() {
      var _t = this;
      this.websocket = await webSocket();
      this.websocket.addEventListener('message', function (event) {
        if (event.data) {
          var data = JSON.parse(event.data)
          if (data.event_type == 5) {
            _t.qrcodeOverdue = true;
          }
          if (data.event_type == 6) {
            _t.fetchMaterialList(true)
          }
        }
      });
    },
    repaintQrcode() {
      this.codeBoxShow = false;
      this.toggleCodeBoxDialog(true);
      this.qrcodeOverdue = false;
    },
    cancelCheck() {
      this.handleMyMateriaChecked(false);
      this.handleMyMateriaCheckedList([]);
    },
    batchDelete() {
      this.handleDelete({ id: this.myMateriaCheckedList.join(',') });
    }
  },
  watch: {
    fetchMarker() {
      if (this.collectType) {
        this.requestCollect()
      } else if (this.currentOp == 'upload') {
        if (this.uploadType == 'music') {
          this.fetchMusicList();
        } else {
          this.cancelCheck();
          this.fetchMaterialList();
        }
      } else {
        this.processGetTemplateList();
      }
    },
    currentOp: {
      immediate: true,
      handler() {
        this.clearSecondTag();
      }
    }
  },
  beforeDestroy() { }
}
</script>

<style scoped>
.mine-menu {
  background: rgba(247, 248, 249, 1);
  box-shadow: -1px 0 0 0 rgba(220, 220, 222, 1);
  padding: 0 16px;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
}

.mine-menu-top {
  padding: 10px 14px 0 0;
  background: #f7f8f9;
  width: 248px;
  box-sizing: border-box;
  position: absolute;
  z-index: 2;
}

.menu-list {
  padding: 0;
}
.preset_view{
  display: flex;
  margin-top:10px;
}
.preset-type-item {
  display: flex;
  width: 100%;
  max-width: 233px;
  border-radius: 2px;
  height: 48px;
  margin-bottom: 12px;
  align-items: center;
}

.preset-type-item ::v-deep .anticon {
  font-size: 16px;
  margin: 1px;
}

.preset-type-item .preset-type-item__icon {
  font-size: 18px;
  margin: 0;
}

.preset-type-item ::v-deep .anticon svg {
  display: block;
}

.search-box {
  display: flex;
  padding-top: 9px;
}

.search-box .ant-btn-icon-only {
  flex-shrink: 0;
}

.check-operation .ant-btn-block {
  flex-grow: 1;
}

.option-group {
  display: flex;
  justify-content: space-between;
}

.template-menu-spacer {
  height: 174px;
  transition: 100ms;
}

.template-menu-spacer--mine {
  height: 140px;
}

.video-template-list {
  overflow: hidden;
}

.video-template-item {
  margin: 0 14px 20px 0;
  width: 108px;
  position: relative;
}

.video-template-item:hover .tem_used_icon {
  display: block;
}

.video-clip-custom-img {
  object-fit: cover;
  width: 100%;
  height: 60px;
}

.preview-icon {
  position: absolute;
  right: 2px;
  bottom: 24px;
}
.material-category__item {
  padding: 2px 0;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin: 0 8px 0 0;
  transition: 0.3s;
  padding:0 8px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height:32px;
}
.material-category__item:hover,
.material-category__item:focus {
  border-color: #40a9ff;
  color: #40a9ff;
}
.material-category__item--active {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}

.material-category__item--active:hover,
.material-category__item--active:focus {
  color: #fff;
  background-color: #40a9ff;
}

.upload-box {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  width:100%;
}

.upload-box button{
  width: 48%;
  flex-grow: inherit !important;
}
.upload-type {
  width: 48%;
  position: relative;
}
.code-box {
  width: 200px;
  height: 200px;
  position: relative;
}
.code-box .qrcode {
  width: 100%;
  height: 100%;
}
.qrcode-overdue {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.qrcode-overdue span {
  cursor: pointer;
  color: #007eff;
}
.tem_used_icon {
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}

.meal-icon {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.video-clip-custom-title {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  /* color: rgba(0, 0, 0, 0.65); */
  margin: 4px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-material {
  width: 800px;
  height: 450px;
}
</style>

<style>
.mine-menu > .ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: fixed;
  top: 400px;
  left: 200px;
}

.video-template-list .ant-spin-container {
  display: flex;
  flex-wrap: wrap;
  margin-right: -14px;
  align-items: flex-start;
  align-content: start;
}

.material-preview .ant-modal-close-x {
  background: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  color: #ffffff;
  margin: 10px 10px 0 0;
  width: 25px;
  height: 25px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
